import { getAuth } from "firebase/auth";

export default {
  methods: {
    getAuthToken() {
      return getAuth().currentUser.getIdTokenResult();
    },
    getUserId() {
      return this.getAuthToken().then(idTokenResult =>
        Promise.resolve(idTokenResult.claims.user_id)
      );
    },
    getStoreId() {
      return this.getAuthToken().then(idTokenResult =>
        Promise.resolve(idTokenResult.claims.storeId)
      );
    },
    getTokenPayload() {
      return this.getAuthToken().then(idTokenResult =>
        Promise.resolve({
          userId: idTokenResult.claims.userId,
          teamId: idTokenResult.claims.teamId
        })
      );
    }
  }
};
